import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { theme } from '../../theme';
import Typography from '../Typography';
import ErrorWarningSquare from '../Icons/ErrorWarningSquare';
import Button from '../Button/Button';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: ${({ theme }) => theme.sizing.sm};
  text-align: center;
  background-color: ${theme.fill.defaultMain};
`;

const ErrorMessage = styled.div`
  background-color: ${({ theme }) => theme.fill.defaultSubtle};
  padding: ${({ theme }) => theme.sizing.xs};
  border-radius: ${({ theme }) => theme.radius.xs};
  border: 1px solid ${({ theme }) => theme.border.defaultWeak};
  max-width: 600px;
  margin-top: ${({ theme }) => theme.sizing.xs};
  margin-bottom: ${({ theme }) => theme.sizing.md};
`;

const ErrorMessageBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  align-items: center;
  justify-content: center;
  max-width: 600px;
`;

const ErrorPage = ({
  errorType = 'generic',
  customMessage = null,
  onRetry = null,
  showRetry = true,
  showGoBack = true,
  showGoHome = true
}) => {
  const { t } = useTranslation('manageEvent');
  const navigate = useNavigate();

  const getErrorMessage = () => {
    if (customMessage) return customMessage;

    switch (errorType) {
      case 'unauthorized':
        return t('errors.unauthorized');
      case 'notFound':
        return t('errors.notFound');
      case 'networkError':
        return t('errors.networkError');
      case 'serverError':
        return t('errors.serverError');
      default:
        return t('errors.generic');
    }
  };

  const handleGoHome = () => {
    navigate('/discover');
  };

  return (
    <ErrorContainer>
      <ErrorMessageBlock>
        <ErrorWarningSquare fill={theme.colors.defaultMain} width={56} height={56} />
        <Typography as="h1" $variant="title-4-semibold" $align="center" color={theme.colors.defaultMain}>
          {t('errorPage.title')}
        </Typography>

        <Typography as="p" $variant="body-1-medium" $align="center" color={theme.colors.defaultStrong}>
          {t('errorPage.subtitle')}
        </Typography>

        <ErrorMessage>
          <Typography as="p" $variant="body-2-medium" $align="center" color={theme.colors.defaultStrong}>
            {getErrorMessage()}
          </Typography>
        </ErrorMessage>

      </ErrorMessageBlock>


      {showGoHome && (
        <Button onClick={handleGoHome} size="l" sizeTablet="l" sizeMobile="l">
          {t('errorPage.goHome')}
        </Button>
      )}

    </ErrorContainer>
  );
};

export default ErrorPage;